import React from "react";
import { useCart } from "../context/CartContext";
import { ShoppingBag, ArrowRight } from "lucide-react";

const FloatingCheckout = () => {
  const { count, subtotal, openCart } = useCart();
  if (count === 0) return null;
  return (
    <button
      onClick={openCart}
      className="fixed bottom-5 left-5 z-40 flex items-center gap-3 bg-primary hover:bg-primary/90 text-primary-foreground rounded-full shadow-xl pl-4 pr-5 h-14 transition-transform hover:scale-105"
    >
      <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-white/20">
        <ShoppingBag className="w-5 h-5" />
        <span className="absolute -top-1 -right-1 bg-accent text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">{count}</span>
      </span>
      <span className="text-left leading-tight">
        <span className="block text-xs opacity-90">{count} item{count > 1 ? "s" : ""} · ₹{subtotal}</span>
        <span className="flex items-center gap-1 font-semibold text-sm">Checkout <ArrowRight className="w-4 h-4" /></span>
      </span>
    </button>
  );
};

export default FloatingCheckout;
